import { useQuery } from '@tanstack/react-query';

import { fetchKpis } from './warehouseApi.js';

// KPI rollup for the management dashboard. The backend rolls everything
// (throughput, lead times, stock age, trip utilisation, stale items) into
// a single payload so the KpiPage only needs one query. 2-minute staleTime
// because these numbers don't flicker — refresh on reload or when a
// mutation invalidates ['warehouse','kpis'] hierarchically.
export function useKpis(params = {}) {
  return useQuery({
    queryKey: ['warehouse', 'kpis', params],
    queryFn: () => fetchKpis(params),
    staleTime: 120_000,
  });
}
